import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './LimitsEmpty.styles';

export const LimitsEmpty = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <S.Title>{t('pages.cabinet.you_dont_have_any_placements_yet')}</S.Title>
      <S.SubTitle>
        {t('pages.cabinet.here_will_be_displayed_limits')}
      </S.SubTitle>
    </S.Box>
  );
};
